module.exports = __webpack_public_path__ + "img/phone.5c525906.svg";